import React, { useCallback, useMemo, useState } from "react";
import np from "../../../../../shared/Images/no_photo.jpg"
import '../../../../../assets/css/revised_css/components/controlManagerThemes/bootstrap/image.css'
import { useAppContainerContext } from "../../../../revised_components/appContainer/context";
import { useNotificationContext } from "../../../../revised_components/contextProviders/notificationContext";
import { PRE_IMG } from "../../../../../shared/Data/typeDirs";
import { PreambleImage } from "../../../../../shared/Objects/newReportObjects/preambleImage";
import { dataSource } from "../../../../../services/dataSource";
import { useSource, useSourceReducer } from "../../../sourceContext";
import { useControl, useControlReducer } from "../../../controlContext";
import { useUserContext } from "../../../../revised_components/contextProviders/userContext";
import { Spinner, Button, OverlayTrigger, Popover} from 'react-bootstrap'
import { Trash2 } from 'react-feather'
// import { ProgressElement } from "../../../../revised_components/progressElement";
// import { filesGetThumbnailBatch } from "../../../../../services/dropboxRequests";
import { useControlHeaderContext } from "../../../controlWrapperContext";
import { getThumbnails, simpleUploadImage } from "../../../../../services/networkRequests";
import { genId } from "../../../../../shared/utils";
import { Input, FormLabel, Textarea } from '@mui/joy';


export function ImageControl({ idx, name, displaySettings = {}, objectMetadata, label, placeholder, options = { thumbnailSize: 'md' } }) {
  const { [idx]: block } = useControl()
  const { imageMap } = useSource()
  // const { [name]: {_id: value } } = block
  const { isDragging, setIsDragging, setProgress } = useAppContainerContext()
  const { user } = useUserContext()
  const { settings: { readOnly: allReadOnly, lockMap } } = useControlHeaderContext()
  const readOnly = useMemo(() => (allReadOnly || (lockMap && lockMap[block._id])), [allReadOnly, lockMap, block._id])
  const displayNotif = useNotificationContext()
  const controlReducer = useControlReducer()
  const sourceReducer = useSourceReducer()
  const [draggingOver, setDraggingOver] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isMouseOver, setIsMouseOver] = useState(false)
  // function progressCallback(status) {
  //   if (!status.isRunning) {
  //     setProgress(false)
  //     return
  //   }
  //   setProgress(
  //     ProgressElement(status.num, status.den, `Moving images from DBGallery: (${status.num} / ${status.den})`)
  //   )
  // }
  const deleteImage = useCallback(()=>{
    controlReducer({idx, name, type:'changed', update: {[name]: null}})
  }, [idx, name ])

  const dropImage = useCallback(async (evt) => {
    setLoading(true)
    setIsDragging(false)
    let data = evt.dataTransfer.getData('text')
    let paths = evt.dataTransfer.files
    let maybeArray = data.split(',')
    let isAlamento = maybeArray[0] === 'alamento' ? maybeArray.splice(0, 1) : false
    console.log("modified array", isAlamento, maybeArray)
    let length = Math.max(maybeArray.length, paths.length)
    if (length !== 1) {
      setLoading(false);
      return displayNotif('danger', 'Please drop exactly one image.');
    }
    displayNotif('info', `Adding image...`);
    let isDBGallery = !paths.length
    let newImageId = genId()
    let newImage = new PreambleImage({
      _id: newImageId,
      parentType: objectMetadata.type,
      _parentId: objectMetadata._id,
      dbg_id: isDBGallery ? maybeArray[0] : null,
      thumbnailSize: options.thumbnailSize,
      storageLocation: !isAlamento? 'dbgallery' : 'alamento'
    })
    let newMapImageData
    console.debug('dropped stuff', isDBGallery, data, maybeArray, paths, evt.dataTransfer.items)
    let queueItem
    if (isDBGallery) {
      if (maybeArray.length > 1) {
        displayNotif('danger', 'Please drop only one image.');
        setLoading(false);
        return
      }
      [newMapImageData, queueItem] = await dbgalleryPutImageAndGetThumbs(maybeArray[0], newImage, options.thumbnailSize, user.token, isAlamento)
    } else {
      if (paths.length > 1) {
        displayNotif('danger', 'Please drop only one image.');
        setLoading(false);
        return
      }
      [newMapImageData, queueItem] = await localPutImageAndGetThumbs(paths[0], newImage, options.thumbnailSize,  user.token)
    }

    sourceReducer({
      type: 'update_imageMap',
      imageData: newMapImageData, name: 'image',
      photo_update: [queueItem]
    })

    setTimeout(() => {
      controlReducer({
        idx, name, type: 'changed', update: {
          [name]: newImage
        },
      })
      setLoading(false)
    })
  }, [options, objectMetadata,  user, setProgress, name, idx, displayNotif, controlReducer, sourceReducer])


  const handleDragEvent = useCallback((evt) => {
    evt.stopPropagation()
    evt.preventDefault()
    if (evt.type === 'drop') {
      try {
        dropImage(evt);
      } catch (e) {
        displayNotif('danger', 'Error adding image. Please try again.');
        setLoading(false);
      }
      setDraggingOver(false);
      setIsDragging(false);
    } else {
      setDraggingOver(evt.type === 'dragover' ? true : false);
    }
  }, [dropImage])




  const [imageData, value] = useMemo(() => {
    const val = block && block[name] && block[name]._id
    const image = imageMap && imageMap[val]
    // console.log('making new imageData', name, !!image, val, imageMap)
    return [image, val]
  }, [imageMap, name, block])
  let comp = useMemo(() => {

    const containerClassName = `report-pre-image-container ${displaySettings.className || ''} `
    // console.log('creating new image component', name, value, !!imageData)
    return (
      <div key={value} className={containerClassName}>
        <div style={{ marginBottom: '5px' }} hidden={!label}>
          <FormLabel sx={{ m: 0 }}>{label}</FormLabel>
        </div>
        <div className={`report-pre-image-outer ${imageData ? '' : 'report-pre-image-box'} ${isDragging ? 'dragging' : ''} ${draggingOver ? ' over' : ''}`}
          onMouseEnter={() => setIsMouseOver(true)}
          onMouseLeave={() => setIsMouseOver(false)}
        >
          {readOnly ? [] : (
            <div className={`report-pre-image-drop-mask`}
              onDragOver={handleDragEvent}
              onDragLeave={handleDragEvent}
              onDrop={handleDragEvent}
            >
              {loading ? (<Spinner animation="border" />) : []}
            </div>
          )}
          {(() => {
            if (imageData) {
              return (
                <div key={value} className="report-pre-image-wrapper">
                  {isMouseOver ? (<DeleteButton onClick={deleteImage} />) : []}
                  <img key={value} alt={value} className="report-pre-image" src={imageData ? `data:image/jpg;base64, ${imageData}` : np} />
                </div>
              )
            } else if (loading) {
              return null
            }
            return (
              <div className="report-pre-image-text">
                {`Drop Image Here (${label || placeholder})`}
              </div>
            )
          })()}
        </div>
      </div>
    )
  }, [imageData, isDragging, isMouseOver, draggingOver, displaySettings, value, readOnly, label, handleDragEvent, placeholder])
  return comp
}

async function localPutImageAndGetThumbs(path, newImage, thumbnailSize,  userToken) {

  let dbg_res = await simpleUploadImage(false, path, userToken)
  newImage.dbg_id = dbg_res.files[0].id
  let savedImage = await dataSource('remDb')[PRE_IMG].put(newImage)
  const queueItem = {
    _id: savedImage._id,
    dbg_id: newImage.dbg_id,
    thumbnailSize: thumbnailSize,
    storageLocation: 'dbgallery'
  }
  let thumbRes = await getThumbnails([queueItem], userToken)
  let newMapImageData = {}
  for (let res of thumbRes) {
    if (res.thumbnail) newMapImageData[res._id] = res.thumbnail

  }
  console.log('got new imageMap data from dbgallery for local upload', newMapImageData, savedImage)
  return [newMapImageData, queueItem]
}

async function dbgalleryPutImageAndGetThumbs(dbg_id, newImage, thumbnailSize, userToken, isAlamento) {

  newImage = await dataSource('remDb')[PRE_IMG].put(newImage)
  const queueItem = { dbg_id, thumbnailSize: thumbnailSize, _id: newImage._id, storageLocation: !isAlamento?'dbgallery' : 'alamento' }
  let thumbnailData = await getThumbnails([queueItem], userToken)

  let newMapImageData = {}
  for (let res of thumbnailData) {
    if (res.thumbnail) newMapImageData[res._id] = res.thumbnail
  }
  console.log('got new imageMap data from dbgallery', newMapImageData, thumbnailData)
  return [newMapImageData, queueItem]
}


function DeleteButton({onClick}){
  let [clicked, setClicked] = useState(false)

  const buttonClick = useCallback(()=>{
    if(!clicked) {
      setTimeout(()=>setClicked(false), 2000)
      return setClicked(true)
    }

    onClick()
    setClicked(false)
  }, [onClick, clicked])

  return (
      <Button variant="danger" onClick={buttonClick} style={{ zIndex:99, position:'absolute', top:5, right:5}}>
        {!clicked? <Trash2 /> : 'Click again to delete photo'}
      </Button> 
  )
}

// function generateThumbnailRequest(image){
//   let {thumbnailSize, path, dbg_id, _id, storageLocation} = image
//   if(!dbg_id) return {path, thumbnailSize}
//   return {
//     _id,
//     dbg_id,
//     thumbnailSize,
//     storageLocation,
//   }
// }